import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ContactForm } from './components/ContactForm';
import { Services } from './components/Services';
import { About } from './components/About';
import { Portfolio } from './components/Portfolio';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SEO } from './components/SEO';
export function App() {
  return <>
      <SEO data-id="element-0" />
      <div className="min-h-screen bg-slate-950 text-white font-sans selection:bg-red-500 selection:text-white" data-id="element-1">
        <TopBar data-id="element-2" />
        <Header data-id="element-3" />

        <main data-id="element-4">
          <Hero data-id="element-5" />

          {/* First Contact Form - Immediately after Hero */}
          <ContactForm title="Get A Free Quote Now" id="contact-form-top" data-id="element-6" />

          <Services data-id="element-7" />
          <About data-id="element-8" />
          <Portfolio data-id="element-9" />
          <Testimonials data-id="element-10" />
          <FAQ data-id="element-11" />

          {/* Second Contact Form - Before Footer */}
          <div className="bg-slate-900 py-10" data-id="element-12">
            <div className="container mx-auto px-4 text-center mb-8" data-id="element-13">
              <h2 className="text-3xl font-bold text-white" data-id="element-14">Ready to Start?</h2>
              <p className="text-slate-400 mt-2" data-id="element-15">
                Let's build something amazing together.
              </p>
            </div>
            <ContactForm title="Discuss Your Project" id="contact-form-bottom" data-id="element-16" />
          </div>
        </main>

        <Footer data-id="element-17" />
        <WhatsAppButton data-id="element-18" />
      </div>
    </>;
}